<template>
    <PointMap :geo-style="tripStyle">
        <template v-for="(_, name) in $slots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps" />
        </template>
    </PointMap>
</template>

<script>
import PointMap from "js/components/maps/PointMap.vue";
import { glyphStyle } from "js/components/maps/styles";

export default {
    name: "TripMap",
    components: { PointMap },
    methods: {
        tripStyle(geo, state) {
            return glyphStyle(geo.getMeta(), state);
        },
    },
};
</script>
